export const isRequireHotelName = (book) => {
  if (book && book.hotelQuantity) return true;
  return book.user.meetingPoint && book.user.meetingPoint.includes('Hotel Pickup');
};

export default {};



// WEBPACK FOOTER //
// ./src/utils/booking.js